import { Box, Heading, VStack } from '@chakra-ui/react';
import { BaseAlert } from '@invara-dev/react-base';
import { stringIsNullOrEmpty } from '../../../../util/helpers/stringHelpers.ts';
import { LabelTextDisplay } from '../../../../components/Common/LabelTextDisplay.tsx';

type TravellerData = {
  FirstName: string;
  LastName: string;
  IsAuthorizedBooker: boolean;
  BookingAuthInstructions?: string;
};

type BookingAuthorizationAlertProps = {
  hasAutomatedApprovalNotes: boolean | undefined;
  automatedApprovalSystemNotes: string | undefined;
  traveller: TravellerData;
};

export const BookingAuthorizationAlert = ({
  traveller,
  hasAutomatedApprovalNotes,
  automatedApprovalSystemNotes
}: BookingAuthorizationAlertProps) => {
  const { FirstName, LastName, IsAuthorizedBooker, BookingAuthInstructions } = traveller;
  const isAuthorized = IsAuthorizedBooker;
  const fullName = `${FirstName} ${LastName}`;
  const hasInstructions = !stringIsNullOrEmpty(BookingAuthInstructions);

  return (
    <BaseAlert status={isAuthorized ? 'success' : 'error'}>
      <VStack align='start' gap='8px'>
        <Box>
          {fullName}{' '}
          {isAuthorized ? (
            'is authorized to book'
          ) : (
            <>
              is{' '}
              <Box as='span' fontWeight='bold'>
                NOT
              </Box>{' '}
              authorized to book
            </>
          )}
        </Box>

        {hasAutomatedApprovalNotes ? (
          <>
            <Heading size='sm' fontWeight='bold'>
              Automated Approval System Enabled
            </Heading>
            <span dangerouslySetInnerHTML={{ __html: automatedApprovalSystemNotes ?? '' }} />
          </>
        ) : (
          hasInstructions && (
            <LabelTextDisplay label='Booking Authorization Instructions/Contact' text={BookingAuthInstructions} />
          )
        )}
      </VStack>
    </BaseAlert>
  );
};
